import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { EbrApiClient } from './ebr-api-client/ebr-api-client.service';
import { Customer, CustomerUser } from './ebr-api-client/ebr-api-client.g';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {

  constructor(
    private authenticationService: AuthenticationService,
    private ebrApiClient: EbrApiClient
  ) { }

  async getCustomers(): Promise<Array<Customer>> {
    if (this.authenticationService.isImpersonating) {
      return Promise.resolve([]);
    }

    const response = await this.ebrApiClient.getCustomers(undefined, undefined, undefined);
    const { data } = response;
    return data ?? [];
  }

  async getUsers(customerName: string): Promise<Array<CustomerUser>> {
    localStorage.setItem('customerName', customerName);
    if (this.authenticationService.isImpersonating) {
      return Promise.resolve([]);
    }

    const response = await this.ebrApiClient.getCustomerUsers(customerName, undefined, undefined, undefined);
    const { data } = response;
    return data ?? [];
  }
}
